import { hostBridge } from '@publicala/delfino';
import type { SessionInitData } from '@publicala/delfino';
import { DEFAULT_SESSION_MOCK, isE2EMockActive } from '../e2eMockGuard';

/**
 * Session API for Volpe.
 * Provides methods to initialize session via hostBridge.
 */
class SessionAPI {
    /**
     * Initialize session and get all session data.
     *
     * This is the main entry point for Volpe initialization via Delfino.
     * Returns complete session data in a single call.
     * Returns mock data in E2E standalone mode.
     *
     * @returns Complete session initialization data
     */
    async initialize(): Promise<SessionInitData> {
        if (isE2EMockActive()) {
            return DEFAULT_SESSION_MOCK;
        }
        return hostBridge.session.initialize();
    }
}

export const sessionAPI = new SessionAPI();
